import React from 'react'
import AttendanceModal from '../attendance-modal'
import useClientLocation from '../../../hooks/use-client-location'

const ExperienceAttendanceScreen = () => {
    const { goBack, params } = useClientLocation()
    const experienceId = params.experienceId
    return (
        <AttendanceModal
            experienceId={experienceId}
            onClose={goBack}
        />
    )
}

export default ExperienceAttendanceScreen